import React from "react"

import Button from "@knowit-alma/common/src/components/atoms/Button/Button"
import Image from "@knowit-alma/common/src/components/atoms/Image/Image"

import styles from "./PricingTable.module.scss"

const PricingTable = ({
  title,
  price,
  description,
  content,
  link,
  image,
  variant = "regular",
}) => {
  return (
    <div className={`${styles.container} ${styles[variant]}`}>
      {image && (
        <div className={styles.image}>
          <Image image={image} widths={[400, 680]} />
        </div>
      )}
      <div className={styles.element}>
        <h3>{title}</h3>
        {price && (
          <p
            className={styles.price}
            dangerouslySetInnerHTML={{ __html: price }}
          ></p>
        )}
        {description && <p className={styles.description}>{description}</p>}
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: content }}
        ></div>
      </div>
      {link && (
        <div className={styles.link}>
          <Button
            href={link.url}
            internalLink={link.target !== "_blank"}
            linkTarget={link.target}
            anchorLink={link.url && link.url[0] === "#"}
            size={variant === "regular" ? "large" : "xs"}
          >
            {link.title}
          </Button>
        </div>
      )}
    </div>
  )
}

export default PricingTable
